import React, { Suspense, forwardRef } from 'react';
import { LoadingFallback } from '@/main/LoadingFallback.atom';
import type { AgGridAsyncProps } from '@/core/tableUtilities/tableUtilities.types';
import type { AgGridReact } from '@seeqdev/ag/grid';

const AgGrid = React.lazy(() => import('@/core/tableUtilities/AgGrid'));

export const AgGridAsync = forwardRef<AgGridReact, AgGridAsyncProps>((props, ref) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <AgGrid {...props} ref={ref}></AgGrid>
    </Suspense>
  );
});
AgGridAsync.displayName = 'AgGridAsync';
